<template>
    <div v-if="dataLoaded && taxConfigs.length">
        <info-widget v-for="tc in taxConfigs" :key="tc.sym_tax.id" :collapsible="true" :is-expanded="widgetsExpanded[tc.sym_tax.id]" @toggle_expand="widgetsExpanded[tc.sym_tax.id] = !widgetsExpanded[tc.sym_tax.id]">
            <template v-slot:title>
                {{ tc.sym_tax.description }}
            </template>
            <template v-slot:headerbutton>
                <button class="btn btn-outline-primary ml-1" type="button" @click.stop.prevent="editTaxConfig(tc)">
                    <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                    Edit
                </button>
            </template>
            <slot>
                <div class="card-body py-2">
                    <div class="form-row">
                        <div v-if="tc.has_non_res_certificate" class="col-12 mui-textfield">
                            <span class="textfield">Yes</span>
                            <label>Has Non-Resident Certificate</label>
                        </div>
                        <template v-else>
                            <div class="col-12 mui-textfield">
                                <span class="textfield">{{ tc.is_exempt ? 'Yes' : 'No' }}</span>
                                <label>Exempt</label>
                            </div>
                            <div v-for="param in visibleParameters(tc)" :key="param.parameter_name" class="col-12 mui-textfield">
                                <span class="textfield">{{ formatParamValue(tc, param) }}</span>
                                <label>{{ param.certificate_line_no }} — {{ param.description }}</label>
                            </div>
                            <div v-if="tc.additional_wh" class="col-12 mui-textfield">
                                <span class="textfield">${{ tc.additional_wh }}</span>
                                <label>Additional Withholding Amount</label>
                            </div>
                        </template>
                    </div>
                </div>
            </slot>
        </info-widget>

        <edit-tax-withholding-modal
            v-if="taxWithholdingModalOpen"
            :client="client"
            :employee="employee"
            :tax-config="currentTaxConfig"
            @updated="onTaxConfigUpdate"
            @close="taxWithholdingModalOpen = false"
        />
    </div>
</template>

<script>
import InfoWidget from '@/components/InfoWidget'
import EditTaxWithholdingModal from './EditTaxWithholdingModal'
import { visibleParameters, formatParamValue } from '@/utils/symTaxConfig'

export default {
    props: ['employee', 'client'],
    components: {InfoWidget, EditTaxWithholdingModal},
    data() {
        return {
            taxConfigs: [],
            dataLoaded: false,
            currentTaxConfig: null,
            taxWithholdingModalOpen: false,
            widgetsExpanded: {}
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData(silent) {
            if (!silent) {
                this.dataLoaded = false
                this.$store.dispatch('START_LOADING')
            }
            this.$api.get(`/clients/${this.client.id}/employees/${this.employee.id}/sym-tax-config`).then(resp => {
                this.taxConfigs = resp
                this.dataLoaded = true
                if (!silent) { this.$store.dispatch('STOP_LOADING') }
            }).catch((errors) => {
                if (!silent) { this.$store.dispatch('STOP_LOADING') }
                this.$bus.showError(errors.__all__)
            })
        },
        editTaxConfig(taxConfig) {
            this.currentTaxConfig = taxConfig
            this.taxWithholdingModalOpen = true
        },
        onTaxConfigUpdate() {
            this.taxWithholdingModalOpen = false
            this.getData()
        },
        visibleParameters(taxConfig) {
            return visibleParameters(taxConfig)
        },
        formatParamValue(taxConfig, param) {
            return formatParamValue(taxConfig, param)
        },
    },
}
</script>
